import { useCallback, FC } from 'react'
import EllipsesDropdown from '../EllipsesDropdown'
import ActionButton from '../ActionButton'
import { clearAllBadges } from 'src/app/session'
import { useAppDispatch, useCreateCsv } from 'src/hooks'
import { Participant } from 'src/app/types'
import { setType } from 'src/app/modal'
import Spinner from '../Spinner'

type SessionFooterProps = {
  participantArr: Participant[]
  id: string
  groupId: string
  name: string
}

const SessionFooter: FC<SessionFooterProps> = ({
  participantArr,
  id,
  groupId,
  name,
}) => {
  const dispatch = useAppDispatch()
  const { isLoading, onExportToCSV } = useCreateCsv({
    participantArr,
    name,
  })

  const onClearBadges = useCallback(() => {
    dispatch(clearAllBadges())
  }, [dispatch])

  const onEndSession = useCallback(() => {
    dispatch(setType({ type: 'sessionEndActive' }))
  }, [dispatch])

  const onDeleteSession = useCallback(() => {
    dispatch(setType({ type: 'sessionDelete', props: { id, groupId } }))
  }, [dispatch, id, groupId])

  return (
    <div className="inline-flex gap-2 justify-end fixed w-full right-0 bottom-0 bg-white p-4 sm:w-mainView">
      <EllipsesDropdown id="session-footer" placement="top-end">
        <div className="flex flex-col gap-3 w-32">
          <button className="text-left" onClick={onClearBadges}>
            Clear All Badges
          </button>
          <button
            className="text-left flex items-center"
            onClick={onExportToCSV}
            disabled={isLoading}
          >
            Export as CSV
            {isLoading && (
              <Spinner className="h-5 w-auto" divClassName="ml-1" />
            )}
          </button>
          <button className="text-left" onClick={onDeleteSession}>
            Delete Session
          </button>
        </div>
      </EllipsesDropdown>
      <ActionButton
        ariaLabel="end session"
        padding="lg"
        type="warning"
        onClick={onEndSession}
      >
        End Session
      </ActionButton>
    </div>
  )
}

export default SessionFooter
